<template>
  <!-- 主要内容 begin -->
  <div id="content-main">
    <a-alert message="提醒：无" banner style="margin-bottom:5px;" />
    <a-alert
      message="信息：无"
      banner
      type="info"
      style="margin-bottom:20px;"
    />
    <!-- 操作栏 -->
    <div class="flex-between" style="flex-flow:row wrap;">
      <div class="flex-start" style="margin-bottom:5px;">
        <div class="search-item">
          <a-input-search
            v-model="keyword"
            placeholder="请输入搜索关键词"
            style="width: 200px"
            @search="search"
          />
        </div>
      </div>
      <!-- <a-button type="primary" icon="plus" @click="modalStatus_1('')"
        >创建</a-button
      >-->
    </div>
    <a-divider dashed />

    <a-table
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :loading="loading"
      size="middle"
      rowKey="pk"
      :scroll="{ x: 700 }"
    >
      <span slot="uploadTime" slot-scope="text">{{ text | datetime }}</span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="modalStatus_1(record)">查看</a>
        </template>
      </span>
    </a-table>

    <!-- 分页 -->
    <Pagination :current="current" :pageSize="pageSize" :total="total" />

    <!-- 弹出层 -->
    <a-modal
      v-if="modalName_1"
      :title="modalName_1.fields.name"
      :visible="modalVisible_1"
      @ok="modalStatus_1"
      :confirmLoading="modalLoading_1"
      @cancel="modalStatus_1"
    >
      <img :src="qiniuURL + modalName_1.fields.url" width="300" />
    </a-modal>
  </div>
  <!-- 主要内容 end -->
</template>

<script>
import Pagination from "../../admin/components/Pagination";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      activity_id: this.$route.params.activity_id,
      // 搜索 参数
      keyword: "",
      // 列表
      list: [],
      loading: false,
      columns: [
        {
          title: "图片名称",
          dataIndex: "fields.name",
          ellipsis: true
        },
        {
          title: "url",
          dataIndex: "fields.url",
          ellipsis: true
        },
        {
          title: "宽度",
          dataIndex: "fields.width",
          ellipsis: true
        },
        {
          title: "高度",
          dataIndex: "fields.height",
          ellipsis: true
        },
        {
          title: "大小",
          dataIndex: "fields.size",
          ellipsis: true
        },
        {
          title: "上传时间",
          dataIndex: "detail.fields.uploadTime",
          scopedSlots: { customRender: "uploadTime" },
          ellipsis: true
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 100
        }
      ],
      // 分页
      total: 0,
      current: 1,
      pageSize: 10,
      // 弹出层
      modalLoading_1: false,
      modalVisible_1: false,
      modalName_1: ""
    };
  },
  created() {
    this.init();
    this.getList();
  },
  methods: {
    // 初始化
    init() {},
    // 查询
    search() {
      this.current = 1;
      this.getList();
    },
    // 列表方法
    getList() {
      this.loading = true;
      let params = {
        limit: this.pageSize,
        current: this.current,
        keyword: this.keyword
      };
      params["activity"] = this.activity_id;
      this.api.getQiniuFileList(params, res => {
        this.loading = false;
        if (res.success) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 分页方法
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    // 弹出层
    modalStatus_1(record = null) {
      this.modalVisible_1 = !this.modalVisible_1;
      this.modalName_1 = this.modalVisible_1 ? record : null;
    }
  }
};
</script>
